export const WEB_BATCH_SUPPORT_URL =
    "https://support.accurx.com/en/articles/7991293-accurx-web-how-to-send-batch-messages";
